module.exports = {
  // 共通
  common: {
    query: "查询",
    search: "搜索",
    add: "添加",
    new: "新增",
    update: "更新",
    edit: "编辑",
    delete: "删除",
    confirm: "确定",
    submit: "提交",
    cancel: "取消",
    back: "返回",
    save: "保存",
    loading: "加载中...",
    operation: "操作",
    error: "错误",
    warning: "警告",
    export: "导出",
    tips: "提示",
    deletedSuccessfully: "删除成功",
    deletionCancelled: "已取消删除",
    confirmClosing: "确认关闭？",
    contentIsUnchanged: "内容未变更",
    anErrorOccurred: "发生错误",
    required: "必填",
    noPermission: "无权限",
    pleaseSelect: "请选择",
    selectDuration: "选择时长",
    reset: "重置",
    details: "详情",
    showSearch: "显示搜索",
    hiddenSearch: "隐藏搜索",
    show: "显示",
    hidden: "隐藏",
    showCol: "显隐列",
    user: "用户",
    colon: "：",
    yes: "是",
    not: "否",
    optional: "可选"
  },

  // 登录画面
  loginPage: {
    language: "语言",
    title: "TQS后台管理系统",
    usernamePlaceholder: "用户名",
    passwordPlaceholder: "密码",
    newPasswordPlaceholder: "新密码",
    verifyCodePlaceholder: "验证码",
    changeVerityCode: "换一张",
    loginBtn: "登录",
    loginBtn2: "修改密码并登录",
    registerLink: "免费注册",
    forgetPasswordLink: "忘记密码？",
    Exitsuccess: "退出成功！",

    // rules:error check
    userNameCheck: "用户名不能为空",
    passwordCheck: "密码不能为空",
    verifyCodeCheck: "验证码不能为空",
    welcomeMessage: "欢迎您！ ",

    // error
    loginFailed: "登录失败！",
    verificationFailed: "验证失败！",
    connectionError: "连接出错啦！"
  },

  // 退出登录
  signOutPage: {
    signOut: "退出登录",
    confirmMsg: "您确定要退出登录吗？"
  },

  // sample画面
  samplePage: {
    inputPlaceholder: "请输入点什么...",
    registerDate: "注册日期",
    name: "姓名",
    address: "住址",
    sex: "性别",
    male: "男",
    female: "女",
    age: "年龄",
    operation: "操作"
  },

  //菜单栏
  headBar: {
    logout: "退出"
  },
  mainPage: {
    useMonitor: "使用监控",
    customerManagement: "客户管理",
    greenJacketForum: "绿夹克讲坛",
    marketingPromotion: "营销推广"
  },
  //修改密码
  changePassword: {
    oldPassword: "旧密码",
    newPassword: "新密码",
    previousStep: "上一步",
    confirm: "确认",
    pleaseRegisterFirst: "请先进行注册",
    userDoesNotExist: "用户不存在",
    oldPasswordError: "旧密码错误！请输入正确的密码！",
    confirmPassword: "确认密码",
    pleaseEnterPassword: "密码不能为空",
    pleaseEnterThePasswordAgain: "请再次输入密码",
    numbers: "8-16位，必须有字母、数字！",
    passwordNotMatch: "两次输入密码不一致!",
    anErrorOccurred: "发生错误",
    newUsersPleaseChangePasswordsFirst: "新用户请先修改密码！",
    passwordChangedSuccessfully: "密码修改成功！",
    atLeast6: "密码长度至少6位"
  },
  // 上传附件
  uploadAttachment: {
    maxUploadNumCheck: "最大上传文件个数：",
    // uploadTypeCheck: "上传的文件只能是.jpg .jpeg .png .gif .pdf格式！",
    sameFileNameCheck: "不支持上传同名文件！",
    fileSizeCheck: "上传的文件大小不能超过50MB！"
  },
  // 课程设置
  courseOption: {
    createTheCourses: "新建课程",
    field: "领域",
    category: "类别",
    courseNumber: "课程编号",
    courseName: "课程名称",
    targetStudents: "目标学员",
    qualificationRequirements: "资格要求",
    defaultForm: "默认形式",
    form: "形式",
    classLanguage: "上课语言",
    defaultDuration: "默认时长",
    duration: "时长",
    days: "天",
    hours: "小时",
    minutes: "分钟",
    numberLimit: "人数限制",
    certificate: "证书",
    coursewareLink: "课件链接",
    introduction: "简介",
    pleaseSelectField: "请选择领域",
    pleaseEnterCourseName: "请输入课程名称",
    pleaseSelectForm: "请选择形式",
    pleaseEnterDuration: "请输入时长",
    pleaseSelectCategory: "请选择类别",
    pleaseEnterCourseNumber: "请输入课程编号",
    pleaseEnterNumberLimit: "请输入人数限制",
    pleaseEnterPositiveInteger: "请输入正整数",
    pleaseEnterNumber: "请输入数字/字母",
    courseInquiry: "课程查询",
    number: "编号",
    courseDetails: "课程详细",
    normalCourses: "付费课程",
    freeCourses: "免费课程",
    classAddress: "地点",
    courseLinkPhone: "手机浏览选课链接",
    createQrCode: "下载二维码",
    browseCourseQRPhone: "手机浏览选课二维码",
    courseType: "课程类型",
    courseQRCode: "课程二维码",
    publicCourse: "公开课程",
    internalCourse: "内部课程",
    videoUrl: "视频链接",
    videoPassword: "视频密码",
    pleaseSelectCourseType: "请选择课程类型",
    pleaseEnterVideoUrl: "请输入视频链接"
  },
  // 排课与定价
  schedulingAndPricing: {
    meetingId: "会议号",
    schedulingAndPricing: "排课与定价",
    recentSchedule: "最近排课",
    enter: "进入",
    unitPrice: "单价",
    classLink: "上课链接",
    teachers: "老师",
    dateAndTime: "日期与时间",
    endDateAndTime: "结束日期与时间",
    linkPassword: "会议密码",
    pleaseDoNotEnterCommas: "请不要输入逗号",
    duplicateMailboxExists: "存在重复老师，请更换",
    pleaseSelectDateAndTime: "请选择日期与时间",
    pleaseSelectEndDateAndTime: "请选择结束日期与时间",
    pleaseEnterUnitPrice: "请输入价格",
    priceFormatIsIncorrect: "请输入正确的价格",
    pleaseSelectCurrency: "请选择货币",
    pleaseEnterClassLink: "请输入上课链接",
    linkFormatIsIncorrect: "链接格式不正确",
    pleaseEnterLinkPassword: "请输入链接密码",
    signUpLink: "报名链接",
    pleaseEnterTheRegistrationLink: "请输入报名链接",
    autoMade: "自动生成",
    videoPassword: "视频密码",
    videoLink: "视频链接",
    pleaseInClassAddress: "请输入上课地点",
    msg1: "结束日期与时间的间隔小于时长"
  },
  //p0211
  p0211: {
    addIndividualUser: "新增个人用户",
    templateImport: "模板导入",
    upload: "上传",
    lastName: "姓",
    firstName: "名",
    nickName: "昵称",
    email: "邮箱",
    inCompany: "在职公司/机构",
    position: "职位",
    englishLastName: "英文姓",
    englishFirstName: "英文名",
    sex: "性别",
    sexSelection: "请选择性别",
    male: "男",
    female: "女",
    telephone: "手机",
    phoneArea: "区号",
    department: "部门",
    remarks: "备注",
    submit: "提交",
    handlEmpty: "清空",
    downloadTemplate: "下载模板",
    uploadTemplate: "上传模板",
    checkLastName: "请输入姓氏",
    checkFirstName: "请输入名字",
    checkEnglishLastName: "请输入英文姓",
    checkEnglishOnly: "只能输入英文",
    checkEnglishFirstName: "请输入英文名",
    checkPhone: "请输入电话号码",
    telephoneFormat: "电话格式不正确!",
    checkEmail: "请输入邮箱",
    correctEmail: "请输入正确的邮箱",
    replaceEmail: "存在重复邮箱，请更换",
    replacePhone: "存在重复手机号，请更换",
    errorOccurred: "发生错误",
    imageFormat: "上传头像图片只能是 JPG 格式!",
    imageSize: "上传头像图片大小不能超过 2MB!",
    length: "长度",
    maxEmail: "最多输入三个邮箱",
    maxPhone: "最多输入三个手机号",
    individualuser: "个人用户信息提交成功！",
    existTemplate: "模板文件不存在，请联系管理员！",
    fileName: "6位课程编号_YYYY-MM-DD_hh-mm.xls",
    errorTemplate: "模板下载失败，请联系管理员！",
    successTemplate: "模板上传成功！",
    templateTypeErr: "上传模板只能是 xls、xlsx格式!",
    errorMessage: "错误信息",
    importFailure: "报名信息导入失败，请联系管理员！",
    importSuccess: "报名信息导入成功！",
    mustInput: "邮箱和手机号，必须有一个输入!",
    msg1: "姓名已更改",
    msg2: "姓和名语言不一致",
    msg3: "只能中文或者英文"
  },
  //p0213
  p0213: {
    basicInformation: "基本信息",
    careerInformation: "职业信息",
    birthday: "生日",
    loginEmail: "登录邮箱",
    birthCountryRegion: "出生国家/地区",
    nationality: "国籍",
    documentType: "证件名称",
    MartialStatus: "婚姻",
    childrenCnt: "孩子",
    motherTongue: "母语",
    hobby: "爱好",
    birthProvince: "出生省",
    birthCity: "市",
    documentNo: "证件号码",
    otherLanguages: "其他语言",
    nowAddress: "现住地址",
    nation: "民族",
    loginPhone: "登录手机",
    correctDocumentNo: "证件号码只能输入英文和数字!",
    replaceDocumentNo: "输入的证件信息存在重复，请确认！",
    userInformationFailed: "个人用户信息查询失败，请联系管理员！",
    saveInformationFailed: "基本信息保存失败，请联系管理员！",
    saveInformationSuccess: "基本信息保存成功！",
    qualification: "资质",
    professionalSkills: "专业技能",
    degree: "学历",
    graduationYear: "毕业年份",
    schoolOfGraduation: "毕业学校",
    AffiliatedCompany: "关联公司/机构",
    servedInOffice: "曾就职",
    personalResume: "个人简历",
    qualificationAttachments: "资质附件",
    remarks: "备注",
    contentIsUnchanged: "内容未变更",
    industryExperience: "行业经验",
    functions: "职能",
    technicalExp: "产品/技术经验",
    projectExp: "项目经验",
    emailPhoneNotDelet: "登录邮箱和手机号不可删除!",
    savedSuccessfullyPS: "专业技能信息保存成功！",
    saveFailedPS: "专业技能信息保存失败，请联系管理员！",
    savedSuccessfullyQS: "资质信息保存成功！",
    saveFailedQS: "资质信息保存失败，请联系管理员！",
    pleaseEnter: "请输入",
    reportsQuery: "报告查询",
    feeSettlement: "费用结算",
    classDateAndTime: "上课日期时间",
    courseNumber: "课程编号",
    courseName: "课程名称",
    introductoryNumber: "介绍人数",
    singleCommission: "单人佣金",
    totalCommission: "佣金总额",
    currency: "货币",
    settlementStatus: "结算状态",
    paymentTime: "支付时间",
    proofOfPayment: "支付凭证",
    view: "查看",
    topTotalCommission: "累计佣金总额：",
    unsettledAmount: "未结算金额：",
    CNY: "CNY",
    pointsCou: "积分统计",
    oprLog: "操作日志",
    oprModule: "应用",
    oprContent: "操作内容",
    oprTime: "操作时间",
    salesUser: "销售人员",
    setSalesUser: "设为销售人员",
    tqsOpr: "TQS操作",
    lastLogin: "上次登录",
    tqsPoints: "TQS积分",
    checkPoints: "请完整填写TQS积分区间",
    checkLog: "没有要导出的操作日志",
    selectExportDate: "选择导出的日期区间",
    startDate: "开始日期",
    endDate: "结束日期",
    setAsTrainer: "设为培训师",
    tag: "标签",
    region: "区域",
    regionErrMsg: "请填写区域信息！",
    subarea: "分区",
    affiliation: "所属机构",
    affiliationEnterMsg: "请选择所属机构",
    isInternalTrainingAuthorized: "内训授权",
  },
  p0321: {
    requiredOptions: '报名必填选项',
    title: '称谓',
    phone: '手机号',
    company: '公司/机构',
    position: '职位',
    birthday: '生日',
    scheduleStatus: '排课状态',
    normal: "正常",
    postponement: "延期",
    suspended: "停课",
    registered: "已报名",
    status: '状态',
    msg1: "此操作将变更课程状态为延期, 是否继续?",
    msg2: "延期成功",
    courseStatus: "课程状态"
  },
  //p0322
  p0322: {
    restore: "恢复",
    suspended: "停课",
    msg1:'确认下架课程吗？',
    msg2:'确认上架课程吗？',
    classInvitation: "上课邀请",
    numbering: "编号",
    courseTitle: "课程名称",
    classDates: "上课日期",
    addStudents: "添加学生",
    name: "姓名",
    audition: "试听",
    auditionTip: "勾选试听学员，即时生效",
    save: "保存",
    saveAudition: "保存成功",
    mail: "登录邮箱",
    cellPhone: "登录手机",
    company: "公司",
    position: "职位",
    state: "状态",
    invited: "已邀请",
    notInvited: "未邀请",
    invitedFaild: "邀请失败",
    sendAnInvitation: "发邀请",
    return: "返回",
    noStudentSelected: "未选择学员",
    invitationSucceeded: "邀请成功",
    emailCanNotBeEmpty: "邮箱不能为空",
    invite: "去邀请",
    qrCode: "报名二维码",
    editClassSchedule: "编辑排课",
    deleteEditClassSchedule: "确认删除排课信息？",
    text1:
      "该排课没有上课链接！请点击[返回->编辑排课]，填入上课链接后再次尝试邀请！",
    text2:
      "该排课没有会议号！请点击[返回->编辑排课]，填入会议号后再次尝试邀请！",
    text3:
      "该排课没有视频链接！请点击[返回->编辑排课]，填入视频链接后再次尝试邀请！",
    applicantNumber: "报名人数",
    person: "人",
    unlimited: "不限",
    cumulativeNumberApplicants: "累计报名人数",
    numberPeopleLearning: "学习中人数"
  },
  //p0323
  p0323: {
    avatar: "头像",
    name: "姓名",
    englishName: "英文姓名",
    nickName: "昵称",
    mail: "TQS登录邮箱",
    cellphoneNumber: "TQS登录手机号",
    submit: "提交",
    noStudentSelected: "未选择学员",
    addedSuccessfully: "添加成功",
    text1: "姓名，英文姓名，邮箱，手机号码"
  },
  p0324: {
    postponementCancellation: "解除延期",
    msg1: "培训师",
    msg2: "失去认证资格，不再显示！",
    msg3: "请设置大于等于当前天的时间。",
    msg4: "此操作将解除课程的延期状态, 是否继续?"
  },
  //p0331
  p0331: {
    classRecord: "上课记录",
    category: "类别",
    numbering: "编号",
    courseTitle: "课程名称",
    classTime: "上课时间",
    numberOfApplicants: "报名人数",
    numberOfStudentsInClass: "上课人数",
    unitPrice: "单价",
    totalCharge: "总收费",
    currency: "货币",
    passingRate: "通过率",
    operate: "操作",
    details: "详情",
    teacher: "老师"
  },
  // 个人用户一览查询画面
  p0212: {
    personalUser: "个人用户",
    headPortrait: "头像",
    userName: "姓名",
    englishName: "英文姓名",
    nickname: "昵称",
    registerDate: "TQS注册日期",
    introducer: "介绍人",
    lastUpdateDate: "上次更新",
    operate: "操作",
    details: "详细",
    searchPlaceholder: "姓名、英文姓名、昵称、邮箱、手机号",
    noFindCompanyInfo: "未查询到公司/机构信息！",
    couponCode: "优惠码",
    couponCodeLevel: "优惠码级别",
    export: "导出优惠码",
    couponFileName: "优惠码一览",
    couponFileFormat: ".xls",
    errorCoupon: "文件下载失败，请联系管理员！",
    existCoupon: "优惠码用户不存在",
    existingCompany: "关联公司"
  },
  //p0332
  p0332: {
    classRecordDetails: "上课记录详细",
    gradeTemplateImport: "成绩模板导入",
    downloadTemplate: "下载模板",
    uploadTemplate: "上传模板",
    pinyinSurname: "拼音_姓",
    pinyinName: "拼音_名",
    mail: "登录邮箱",
    cellPhone: "登录手机",
    company: "公司",
    position: "职位",
    yes: "是",
    no: "否",
    noClass: "否上课",
    testScores: "考核成绩",
    noPass: "否通过",
    submit: "提交",
    errorMessage: "错误信息",
    thisCourseIsNot: "该课程未绑定证书！请先绑定证书后再次尝试提交！",
    submittedSuccessfully: "提交成功",
    importSucceeded: "成绩信息导入成功，且已自动提交",
    pageRefreshed: "页面已刷新",
    unmodified: "未修改",
    gradesCannotBeEmpty: "成绩不能为空",
    enterNumbersOnly: "只能输入数字",
    lastNameCannotBeEmpty: "姓不能为空",
    englishOnly: "只能输入英文",
    nameCannotBeEmpty: "名不能为空",
    setLinkCourseRecord: "视频回放",
    enterLinkRecord: "请输入课程录像链接",
    enterLinkTitle: "请输入课程链接标题",
    linkFormatIsIncorrect: "链接格式不正确",
    linkRecordSetSuccess: "课程录像链接设置成功!",
    courseVideoLink: "课程视频链接",
    downloadTheVideoQrCode: "下载二维码",
    btn1: "下载视频回放二维码",
    btn2: "下载视频回放推广二维码",
    msg1: "未设置视频回放链接",
    noLessons: "未上课",
    classesHaveBeenTaken: "已上课",
    bt3: "二维码下载",
    bt4: "复制链接",
    msg2: "复制成功",
    setLinkCourseRecord2: "视频回放推广",
    isInternalTrainingAuthorized: "内训授权",
  },
  // 证书管理
  certificateManagement: {
    newCertificate: "新设证书",
    definitionName: "定义名称",
    definitiontemplate: "定义模板",
    relatedCourses: "关联课程",
    issuanceMethod: "发证方式",
    aCourse: "一课一证",
    multipleCourses: "多课一证",
    clickAndDbClick: "单击选中，双击预览",
    pleaseEnterDefinitionName: "请输入定义名称",
    pleaseSelectDefinitionTemplate: "请选择定义模板",
    pleaseSelectRelatedCourses: "请选择关联课程",
    pleaseSelectIssuanceMethod: "请选择发证方式",
    duplicateRelatedCourseExists: "关联课程存在重复",
    courseCertificateDescription: "课程证书描述",
    pleaseEnterDescription: "请输入课程证书描述",
    msg1: "请输入课程名称"
  },
  // 查看证书
  viewCertificate: {
    checkCertificate: "编辑证书设置",
    deleteInformation: "确认删除证书信息？",
    queryingCertificate: "查询证书",
    name: "名称",
    template: "模板",
    associateCourse: "关联课程",
    authenticationMethod: "发证方式",
    lastEdited: "上次编辑",
    display: "显示"
  },

  p0101: {
    userStatistics: "个人用户注册统计",
    registrationNumbers: "TQSCloud个人用户注册数量：",
    month: "月份",
    curMonthUserNums: "当月新注册个人用户数量",
    curMonthAdminNums: "当月新注册管理者数量",
    cumMonthNumbers: "累计个人用户注册数量"
  },

  p0102: {
    companyStatistics: "公司/机构注册统计",
    registrationNumbers: "TQSCloud注册公司/机构数量：",
    month: "月份",
    curMonthNumbers: "当月注册公司/机构数量",
    cumMonthNumbers: "累计注册公司/机构数量"
  },
  // 公司机构查询一览
  p0202: {
    companyOrganizationName: "公司/机构名称",
    companyRegisteredName: "注册名称",
    companyShortName: "简称",
    englishName: "英文名称",
    managers: "管理者",
    numberOfPeople: "人员数量"
  },
  p0201: {
    enterCompanyInformation: "请填写四位字符及以上正确的公司名称",
    companyInfo: "公司/机构基本信息",
    companyUserInfo: "公司/机构人员信息",
    companyName: "注册名称",
    companyAbbrName: "简称",
    companyTaxNumber: "公司税号",
    conntryName: "注册国家/地区",
    registerAddr: "注册地",
    registerAddrs: "注册地址",
    companyEnName: "英文名称",
    contact: "公司代表/联系人",
    telephone: "联系电话",
    address: "联系地址",
    industry: "所属行业",
    companyWeb: "公司网址",
    remarks: "备注",
    information: "公司资料",
    automatically: "自动获取",
    upload: "上传",
    country: "中国",
    industryName: "行业名称",
    save: "保存",
    phoneArea: "+86",
    province: "省",
    city: "市",
    county: "区",
    companyAlreadyExists: "该公司已存在",
    enterCompanyName: "请输入注册名称",
    enterTaxNumber: "请输入公司税号",
    checkTel: "手机号格式错误",
    pleaseAddCompInfo: "请先添加公司/机构基本信息!"
  },
  p0201companyUserInfo: {
    incorrectFormatOfEnterpriseTaxNumber: "税号格式错误",
    addRegisteredUser: "  添加已注册用户",
    addNoRegisterUser: "  添加未注册用户",
    personalUser: "个人用户",
    headPortrait: "头像",
    userName: "姓名",
    englishName: "英文姓名",
    nickname: "昵称",
    registerDate: "注册日期",
    phoneNo: "手机",
    email: "邮箱",
    searchPlaceholder: "姓名/手机/邮箱",
    position: "职位",
    department: "部门",
    add: "添加",
    view: "公司/机构人员信息一览",
    validateEmAndPho: "手机号和邮箱必须填写一项!"
  },
  p0204: {
    companyAddress: "公司地址",
    selectProvince: "选择省直辖市",
    selectCity: "选择市区",
    china: "中国",
    registeredName: "注册名称",
    shortName: "简称",
    registration: "注册地",
    province: "省",
    city: "市",
    area: "区",
    registeredAddress: "注册地址",
    contactNumber: "联系电话",
    contactAddress: "联系地址",
    industry: "所属行业",
    companyTaxNumber: "公司税号",
    countryOfRegistration: "注册国家/地区",
    englishName: "英文名称",
    companyRepresentativeContact: "公司代表/联系人",
    companyWebsite: "公司网址",
    remark: "备注",
    companyInformation: "公司资料",
    edit: "编辑",
    save: "保存",
    canNotBeEmpty: "不能为空",
    pleaseEnterYourPhone: "请输入手机",
    wrongPhoneFormat: "手机格式错误",
    successfullySaved: "保存成功"
  },
  p0203: {
    basicInformation: "基本信息",
    personnelInformation: "人员信息"
  },
  p0205: {
    deleteThisUser: "是否删除该用户？",
    deleteThisCompany: "是否删除该公司？"
  },
  newYouHuiMa: {
    createCouponCode: "创建优惠码",
    certificate: "证书",
    TQSTemplateUsage: "TQS模板使用",
    greenJacketClassName: "绿夹克上课名称",
    greenJacketClassDate: "绿夹克上课日期",
    individualUser: "个人用户",
    queryCriteria: "姓名/英文姓名/手机/Email/资质",
    promoCodeLevel: "优惠码级别",
    avatar: "头像",
    name: "姓名",
    englishName: "英文姓名",
    email: "邮箱",
    phoneNumber: "手机号码",
    affiliation: "关联公司",
    registerDate: "注册日期",
    lastLogin: "上次登录",
    createAndNotify: "创建并通知",
    qrCodeTitle: "扫码获取优惠码",
    createQrCode: "下载二维码"
  },
  p0412: {
    defaultOffer: "默认优惠设置",
    courseNumber: "课程编号",
    courseName: "课程名称",
    studentDiscount: "学员优惠",
    introducerCommission: "介绍人佣金",
    deductionAmount: "基于标准价的减扣金额",
    deductionRatio: "基于标准价的减扣比例",
    quoteCurrency: "（报价货币）",
    fixedAmount: "固定金额",
    ratio: "基于标准价的比例",
    twoDecimals: "请输入数字",
    integer: "请输入0-99的整数",
    enterNumber: "请选择课程编号",
    enterName: "请选择课程名称",
    OfferSetSuccess: "优惠设置提交成功！"
  },
  p0413: {
    specialOffer: "特殊优惠设置",
    limitedTime: "限时特殊优惠",
    specifyPerson: "指定人特殊优惠",
    courseNumber: "课程编号",
    courseName: "课程名称",
    queryCriteria: "姓名/英文姓名/昵称/手机/Email/优惠码",
    classDate: "上课日期时间",
    studentDiscount: "学员优惠",
    introducerCommission: "介绍人佣金",
    couponCode: "优惠码",
    individualUser: "个人用户",
    name: "姓名：",
    email: "邮箱：",
    phone: "手机号：",
    codeCoupon: "优惠码：",
    selectCourse: "请选择课程编号、课程名称",
    enterQuery: "请输入姓名、英文姓名、昵称手机、邮箱、优惠码进行查询",
    specialSetSuccess: "指定人优惠提交成功！",
    LimitSetSuccess: "限时优惠提交成功！",
    offerSettings: "优惠设置"
  },
  p0401: {
    intro: "介绍人",
    sales: "销售人员",
    lastUpdated: "上次更新",
    tqsPoints: "TQS积分",
    position: "职位",
    promoCodeLevel: "优惠码级别",
    promoCode: "优惠码",
    emailGroupQueryMemberListEmail: "Email群查询成员一览",
    tqsOperation: "TQS操作"
  },
  // 群公告、Email群查询P0403、P0404
  emailGroup: {
    groupAnnouncement: "群公告",
    queryEmailGroup: "Email群查询",
    emailGroupName: "Email群名称",
    fuzzySearch: "模糊搜索",
    groupDescription: "群摘要/描述",
    peopleCount: "人数",
    createDate: "创建日期",
    lastAnnouncement: "上次公告",
    state: "状态",
    operation: "操作",
    historical: "历史公告",
    void: "作废",
    effective: "有效",
    recover: "恢复",
    newAnnouncement: "新公告",
    nickName: "昵称",
    graduate: "开始年份小于结束年份",
    createEmailGroup: "新建Email群",
    newEmailGroupName: "新增Email群名称",
    newEmailGroupDesc: "Email群摘要/描述",
    curCompany: "现任职公司",
    education: "学历",
    beforeCompany: "曾任职公司",
    graduateYear: "毕业年份",
    couponCodeLevel: "优惠码级别",
    userSearchValue: "关键字",
    inputGroupName: "请输入Email群名称",
    inputGroupDesc: "请输入Email群简介",
    maxLength255: "最大长度255字符",
    maxLength500: "最大长度500字符",
    to: "至",
    addMembers: "请选择群成员",
    email: "邮箱",
    qtr: "资质/职位/居住地",
    pleaseSelect: "请选择成员"
  },
  // 公告模板设置P0402
  P0402: {
    announcementTemplateSetting: "公告模板设置",
    newTemplate: "新增模板",
    templateName: "模板名称",
    lastUpdate: "上次更新",
    newGroupTemplate: "新增群模板",
    create: "创建",
    title: "标题",
    content: "内容",
    editGroupTemplate: "编辑群模板",
    saveAsNewTemplate: "另存为新模板",
    ifDeleteTemplate: "确认删除该模板？",
    variable: "变量",
    remark: "注：如需添加变量，请点击变量按钮"
  },
  // 新公告
  p0403: {
    newAnnouncement: "新公告",
    announcementTemplate: "添加公告模板",
    select: "选择",
    courseName: "课名",
    dateAndTime: "日期与时间",
    time: "时间",
    company: "公司",
    address: "地点",
    reportLink: "学习报告链接",
    content1: "您的优惠码是【优惠码】，用于本次报名可以直接抵扣【金额】元。",
    content2: "，用于本次报名可以直接抵扣",
    content3: "元。",
    body: "正文",
    attachment: "添加附件",
    selectAttachment: "选择文件",
    send: "发送",
    selectAnnouncementTemplate: "选择公告模板",
    selectTemplate: "选择模板",
    selectCourseName: "选择课名",
    selectDateAndTime: "选择日期与时间",
    selectCompany: "选择公司",
    selectAddress: "选择地点",
    pleaseSelectCourseName: "请选择课名",
    pleaseSelectDateAndTime: "请选择日期与时间",
    pleaseSelectCompany: "请选择公司",
    pleaseSelectAddress: "请选择地点",
    sendSuccess: "发送任务创建成功，系统正在自动群发",
    allStaffAnnouncement: "全员公告",
    pleaseEnterContent: "请输入内容",
    pleaseEnterEmailTitle: "请输入主题",
    checkContent: "您输入的内容已达到上限，请删减!",
    emailTitle: "主题",
    imgCheck: "只允许上传大小为15M以内的图片",
    maxLength200: "主题长度最大为200字符!",
    preview: "预览",
    addLink: "添加链接",
    updateLink: "修改链接",
    courseLink: "当前课程链接",
    studyReportLink: "学习报告链接",
    courseCode: "课程二维码",
    courseEnrollCode: "课程报名二维码",
    videoCode: "视频回放二维码",
    videoCodePromote: "视频回放推广二维码",
    courseCodeCourseNumber: "课程二维码课名",
    courseEnrollCodeCourseNumber: "课程报名二维码课名",
    courseEnrollCodeDateAndTime: "课程报名二维码日期与时间",
    videoCodeCourseNumber: "视频回放二维码课名",
    videoCodeDateAndTime: "视频回放二维码日期与时间",
    studyReportCourseNumber: "学习报告链接课名",
    studyReportDateAndTime: "学习报告链接日期与时间",
    videoCodePromoteCourseNumber: "视频回放推广课名",
    videoCodePromoteDateAndTime: "视频回放推广日期与时间",
    couLink: "课程",
    phoLink: "图片",
    freeLink: "自由链接",
    enterLink: "请输入链接",
    enterImg: "请上传图片"
  },
  p0214: {
    examScores: "考试成绩"
  },
  // 发票信息查询
  p0351: {
    invoiceInquiry: "发票信息查询",
    notIssued: "未开具",
    issued: "已开具",
    toIssued: "去开具"
  },
  p0352: {
    recipientinfo: "姓名/电话/开票公司",
    selectDate: "选择日期",
    batchIssuance: "批量开具",
    exportOfInvoiceInfo: "发票信息导出",
    viewInvoiceInfo: "查看发票信息",
    recipientName: "收件人姓名",
    contactNumber: "联系电话",
    registrationTime: "报名时间",
    invoiceType: "发票类型",
    courseName: "课程名称",
    classTime: "上课时间",
    noInvoiceInfoExport: "暂无发票信息",
    noInvoiceInfoExportTitle: "发票信息一览（未开具）_",
    invoiceInfoExportTitle: "发票信息一览（已开具）_",
    invoiceInfoExportFail: "发票信息导出失败",
    exportFileFormat: ".xls",
    batchIssuanceSuccess: "开具成功",
    invoiceTypeDialog: "发票类型：",
    invoiceInfo: "发票信息",
    invoiceTitle: "发票抬头：",
    serviceItems: "服务项目：",
    TaxpayeridentifyNo: "纳税人识别号：",
    companyRegistAdd: "公司注册地址：",
    CorporateFinancialTel: "公司财务电话：",
    bankOfDeposit: "开户银行：",
    bankAccountNo: "银行账号：",
    wayOfReceive: "领取方式：",
    recipientnName: "收件人姓名：",
    contactNo: "联系电话：",
    postalAdd: "邮递地址：",
    email: "电子邮箱：",
    timeOfIssue: "开具时间",
    keywords: "关键字",
    totalAmount: "入账总额：",
    remarks: "备注："
  },
  P0361: {
    orderInquiryTitle: "订单信息查询",
    courseName: "课程名称",
    paymentTime: "订单支付时间",
    date: "选择日期",
    keywords: "关键字",
    coursePrice: "课程单价",
    applicants: "报名人数",
    couponCode: "优惠码",
    discountedPrice: "优惠价格",
    totalCredit: "入账总额",
    purchaser: "购买人",
    purchaserPhone: "购买人手机",
    telephone: "手机",
    invoicingCompany: "开票公司",
    remark: "备注",
    null: "无",
    details: "详情",
    paymentMethod: "支付方式",
    orderId: "订单号"
  },
  p0341: {
    certificatePreview: "证书预览",
    previewIsNotSupported: "不支持预览",
    thirdPartyCertificateUpload: "第三方证书上传",
    allowed: "允许",
    notAllowed: "不允许",
    selectThirdPartyUpload: "请选择是否第三方上传",
    msg1:'请填写课程名称和课程证书描述'
  },
  p0416: {
    statisticalCommissions: "统计佣金",
    dateTime: "上课日期时间",
    courseNumber: "课程编号",
    courseName: "课程名称",
    totalCommission: "佣金总额",
    amountPaid: "已付金额",
    currency: "货币",
    paymentTime: "支付时间",
    details: "明细",
    noSettled: "待结算",
    settled: "已结算",
    introducer: "介绍人",
    phone: "手机号",
    company: "关联公司",
    couponCode: "优惠码",
    introduceNum: "介绍人数",
    singleCommission: "单人佣金",
    pay: "支付",
    bulkPayments: "批量支付",
    selectPaymentTime: "选择支付时间",
    uploadPayProof: "上传支付凭证",
    pleaseSelectDateTime: "请选择支付时间",
    export: "导出",
    optionFaild: "操作失败",
    pleaseSelectUser: "请选择批量支付的人员",
    ExportFail: "导出失败",
    noFindCommissionInfo: "暂无待结算明细信息"
  },
  pointsRule: {
    title: "TQS Points 积分规则设定",
    company: "注册公司账户积分",
    companyPoint: "每成功注册一个公司帐户，用户积",
    TQSPoints: "TQS分",
    countryTitle: "指定国家特别设置：",
    register: "注册",
    selectCountry: "请选择国家",
    countryPoints: "的公司帐户，",
    user: "用户积",
    points8D: "使用8DReport积分",
    D8Points: "完成一个8D报告，D8组长积",
    D1Points: "在8D报告中，每成功邀请一个组员或联系人注册，邀请人积",
    share8DPoints: "通过分享8D报告，每成功注册一个受享人，分享人积",
    qualityToolPoints: "使用质量工具积分",
    fishPoints: "完成一个鱼骨图报告分析，用户积",
    points5W2H: "完成一个5W2H报告分析，用户积",
    points5WHY: "完成一个5Why报告分析，用户积",
    pointsIN: "完成一个Is / IsNot报告分析，用户积",
    shareTools: "通过分享质量工具报告，每成功注册一个受享人，分享人积",
    greenJacketPoints: "使用绿夹克讲坛积分",
    GJFPoints: "每完成一次GJF课程，积",
    coefficient: "+ （支付费用  x",
    coefficientTQSPoints: "%  ）   TQS分",
    ps: "(注：支付费用用CNY计算，若支付美金将转换成CNY，计算方式四舍五入法)",
    pointCoupon: "受益人使用优惠码每完成一次GJF课程，优惠码主人积",
    submit: "提交",
    noChange: "内容未改变",
    submitSuccessfully: "提交信息成功",
    submitfailed: "提交信息失败",
    almostPointsRule: "请输入正整数，且最多输入三位",
    coefficientRule: "只能输入0到100的整数或者一位小数"
  },
  p0216: {
    currentPoints: "当前积分：",
    points: " 积分",
    usedPoints: "累计已使用：",
    pleaseSelect: "请选择",
    selectTime: "时间",
    select: "查询",
    apply: "应用",
    operation: "操作",
    selectPoints: "积分"
  },
  // 销售人员管理
  salespersonMgt: {
    title: "销售人员查询",
    personalUser: "个人用户",
    searchPlaceholder: "姓名、英文姓名、昵称、邮箱、手机号",
    existingCompany: "关联公司",
    fuzzySearch: "模糊搜索",
    managementUser: "管理用户",
    cancelSaleQualify: "取消销售资格",
    nameZh: "姓名",
    nameEn: "英文姓名",
    nickname: "昵称",
    registerPhone: "注册手机",
    registerEmail: "注册邮箱",
    queryExistingCo: "关联公司",
    position: "职位",
    manageUserNum: "管理用户数量",
    cancelQualifyConfirm: "确认取消销售资格？",
    addSaleTitle: "新增销售人员",
    addMgtUserTitle: "新增管理用户",
    mgtUserTitle: "管理用户",
    addMgtUser: "新增用户",
    delMgtUserConfirm: "确认删除对该用户的管理？"
  },
  p0433: {
    personalUser: "个人用户",
    headPortrait: "头像",
    userName: "姓名",
    englishName: "英文姓名",
    nickname: "昵称",
    introducer: "介绍人",
    lastUpdateDate: "上次更新",
    operate: "操作",
    details: "详细",
    searchPlaceholder: "姓名、英文姓名、昵称、邮箱、手机号",
    searchPlaceholder1: "课程名称，编号",
    noFindCompanyInfo: "未查询到公司/机构信息！",
    couponCode: "优惠码",
    couponCodeLevel: "优惠码级别",
    export: "导出优惠码",
    couponFileName: "优惠码一览",
    couponFileFormat: ".xls",
    errorCoupon: "文件下载失败，请联系管理员！",
    existCoupon: "优惠码用户不存在",
    existingCompany: "关联公司",
    position: "职位",
    courseNumber: "课程编号",
    courseName: "课程名称",
    currency: "货币",
    classTime: "上课时间",
    uploadPayProof: "上传支付凭证",
    enterLink: "请输入链接",
    selectTime: "时间",
    state: "状态",
    proofOfPayment: "支付凭证",
    selectPaymentTime: "选择支付时间",
    paymentTime: "支付时间",
    qualificationStatus: "资格状态",
    qualificationSize: "资格数量",
    registeredMobile: "注册手机",
    registeredEmail: "注册邮箱",
    certifiedCourseCount: "认证课程数",
    certificationCourse: "认证课程",
    classDetails: "上课明细",
    cancelTrainerQualification: "取消培训师资格",
    restoreTrainerQualification: "恢复培训师资格",
    addTrainer: "新增培训师",
    normal: "正常",
    cancelled: "取消",
    addCourse: "新增课程",
    uncertain: "不确定",
    withTravelExpense: "含差旅费",
    withoutTravelExpense: "不含差旅费",
    enterTrainingCost: "请输入培训费用",
    cumulativeTrainingCost: "累计培训费用",
    unsettledTrainingCost: "待结算培训费用",
    satisfactionSurvey: "满意度调查",
    payment: "支付",
    paymentDetails: "支付明细",
    paymentVoucher: "支付凭证",
    enterPaymentTime: "请输入支付时间",
    selectUserToAdd: "请选择要添加的用户",
    enterNumber: "请选择课程编号",
    enterName: "请选择课程名称",
    OfferSetSuccess: "优惠设置提交成功！",
    registerDate: "注册日期",
    trainingCost: "培训费用",
    trainerSearch: "培训师查询",
    travelExpense: "差旅费用",
    editCourse: "编辑课程",
    operationSuccess: "操作成功",
    disqualifyTraining: "此操作会取消培训资格",
    view: "查看",
    satisfactionSurveyLink: "满意度调查链接",
    unsettled: "未结算",
    deleteCourseWarning: "此操作会删除认证课程",
    settled: "已结算",
    addedSuccessfully: "添加成功",
    selectCourse: '请选择课程',
  },
  // ASQMS
  orderManagement: {
    title: 'ASQMS 订单管理',
    purchaser: '购买人',
    purchaserPlaceholder: '邮箱/手机号/地址',
    bookName: '书籍名称',
    orderStatus: '订单状态',
    invoicingFlag: '发票状态',
    orderPayType: '支付方式',
    orderPayTime: '支付时间',
    selectDate: '选择日期',
    orderPayTime1: '订单支付时间',
    orderId: '订单编号',
    bookName1: '书籍详情',
    seeThemAll: '查看全部>',
    recipientName: '收件人',
    unitPrice: '单价',
    purchaseNumber: '购买数量',
    entryPrice: '支付金额',
    currency: '货币',
    invoice: '发票',
    completeThePayment: '完成支付',
    shipments: '发货',
    notShipped: '未发货',
    shipped: '已发货',
    pendingPayment: '待支付',
    notRequired: '不需要',
    required: '需要',
    weChat: '微信',
    alipay: '支付宝',
    payPal: 'PayPal',
    offlinePayment: '线下支付',
    shippingAddress: '发货地址',
    invoiceInformation: '发票信息',
    // 地址一览
    email: "邮箱",
    telephone: "手机",
    company: '公司/机构',
    country: "国家",
    china: "中国",
    courseName: '配送地址',
    purchaseNumber1: '数量',
    // 发票一览
    invoiceType: "发票类型",
    invoiceTitle: "发票抬头",
    serviceItems: "服务项目",
    TaxpayeridentifyNo: "纳税人识别号",
    companyRegistAdd: "公司注册地址",
    CorporateFinancialTel: "公司财务电话",
    bankOfDeposit: "开户银行",
    bankAccountNo: "银行账号",
    postalAdd: "邮递地址",
    trainingFees: "培训费",
    electron: "电子",
    expressDelivery: "快递",
    totalAmount: "入账总额",
    wayOfReceive: "领取方式",
    recipientnName: "收件人姓名",
    email1: "电子邮箱",
    contactNo: "联系电话",
    remarks: "备注",
    msg11: '订单[',
    msg12: ']已完成发货？',
    msg21: '订单[',
    msg22: ']已完成线下支付？'
  },
  newsAnncmnt: {
    asqmsNewsAnncmnt: 'ASQMS 新闻与公告',
    newsAnncmnt: '新闻与公告',
    title: '标题',
    titleZh: '中文标题',
    titleEn: '英文标题',
    titleName: '标题名称',
    creationTime: '创建时间',
    publish: '发布',
    introduction: "简介",
    coverLocationCode: "上传封面图",
    content: "新闻与公告详情",
    msg1: '确定发布此新闻与公告？',
    msg2: '确定删除此新闻与公告？',
    msg3: '请填写标题',
    msg4: '请填写中文标题',
    msg5: '请填写英文标题',
    fileSizeCheck: "上传的文件大小不能超过5MB！",
    status: '状态',
    toBePublished: '待发布',
    published: '已发布',
  },
  resourceUserQuery:{
    resourceUser: "资源用户",
    personalUser: "个人用户",
    headPortrait: "头像",
    userName: "姓名",
    englishName: "英文姓名",
    nickname: "昵称",
    details: "详细",
    searchPlaceholder: "姓名、英文姓名、手机、邮箱",
    searchKey: "请输入关键字",
    enterSubarea: "请输入分区",
    enterRemarks: "二维码备注说明，仅用于区分二维码",
    tag: "标签",
    region: "区域",
    subarea: "分区",
    email: "邮箱",
    phone: "手机",
    existingCompany: "关联公司",
    resourceUserImport: "资源用户导入",
    setTag: "设置标签",
    setArea: "设置区域",
    qRCodeDownload: "注册二维码下载",
    downloadCodeTitle: "下载二维码",
    download: "下载",
    resetTag: "重置标签",
    registerResourceCode: "注册二维码",
    existTemplate: "模板文件不存在，请联系管理员！",
    fileName: "6位课程编号_YYYY-MM-DD_hh-mm.xls",
    errorTemplate: "模板下载失败，请联系管理员！",
    successTemplate: "模板上传成功！",
    templateTypeErr: "上传模板只能是 xls、xlsx格式!",
    importFailure: "信息导入失败，请联系管理员！",
    resourceUserTemplate: "资源用户导入模板.xls",
    submitSuccess: "提交成功！",
    errorOccurred: "发生错误",
    userQuery: "用户查询",
    errorMessage: "错误信息",
    bindingState: "微信绑定",
    notBound: "未绑定",
    bound: "已绑定",
    remarks: "备注",
    msg1:"已超过最大文字数",
    affiliation: "所属机构",
    affiliationEnterMsg: "请选择所属机构"
  },
  demandMgt:{
    subarea: "分区",
    searchKey: "请输入关键字",
    demandMgtTitle:'需求管理',
    jobTitle: '需求标题',
    jobDescription: '需求内容',
    numberOfWorkers: '需要人数',
    jobTime: '工作时间',
    countSend: '发送人数',
    countAccept: '接受人数',
    status: '状态',
    updateTime:'最新发布时间',
    postJobRequirements:'发布工作需求',
    to: "至",
    pleaseEnter: "请输入",
    publish: '发布',
    finish: '完成',
    acceptFlag: '接受状态',
    acceptTime: "接受时间",
    basicInformation: '基础信息',
    receivingStaff: '接收工作人员',
    startDate: "开始日期",
    endDate: "结束日期",
    unpublished: "未发布",
    published: "已发布",
    canceled: "已取消",
    done: "已完成",
    msg1:'确定要发布吗?',
    msg2:'确定要取消吗?',
    msg3:'确定要完成吗?',
    msg4:'确定要删除吗?',
    noResponse: "未回应",
    accepted: "已接受",
    rejected: "已拒绝",
    msg5:'工作开始时间需要大于当前时间',
    msg6:'工作结束时间需要大于开始时间',
    msg7:'请选择人员',
    msg8:'请选择未发送的人员',
    sendAgain:"再次发送",
    msg9:"发送成功",
    affiliation: "所属机构",
  }
};



// WEBPACK FOOTER //
// ./src/language/langs/zh.js